import { Link, Badge, DataTable, Filters, Tooltip, Button, Box } from '@shopify/polaris';
import { formatToCurrency, getTableFooter, truncate } from '../../../shared/components/functions';
import { addFilters, applyFilters, handleFilterChange, removeFilter, handleFiltersClearAll } from '../../../shared/components/listFilter';
import InvoicePdfPreviewButton from '../../../shared/components/InvoicePdfPreviewButton';

export default function InvoiceLinesTable({ items, page, setPage, filters, setFilters, navigate, filterLoading }) {
  const rows = Array.isArray(items)
    ? items.map((item) => {
        return [
          <Link removeUnderline url={'/invoices_in/' + item.faktuurnr}>
            {item.FactuurInNummer}
          </Link>,
          <div style={{ marginTop: '-5px', marginBottom: '-5px' }}>
            <InvoicePdfPreviewButton s3ObjectKeys={item.S3ObjectKeys} buttonLabel="View PDF" buttonSize="slim" buttonEmoji="👀" modalTitle="Invoice PDF Preview" />
          </div>,
          <Link removeUnderline url={'/companies/' + item.supplier_number}>
            {item.supplier_land_id === 300 && '🇧🇪 - '}
            {truncate(item.supplier_name, 30)}
          </Link>,
          item.datum ? String(item.datum)?.substring(0, 10) : '',
          truncate(item.tekstlijn, 40),
          item.ArtikelCode || '-',
          formatToCurrency(item.VP),
          item.aantal,
          formatToCurrency(item.lineTotal),
          formatToCurrency(item.lineTotalWithVAT),
          formatToCurrency((item.lineTotalWithVAT || 0) - (item.lineTotal || 0)),
          `${item.BTW || 0}%`,
          item.MuntVP || '-'
        ];
      })
    : [];

  const totals =
    items.length > 0
      ? [
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          formatToCurrency(items.reduce((p, c) => p + (c.lineTotal || 0), 0)),
          formatToCurrency(items.reduce((p, c) => p + (c.lineTotalWithVAT || 0), 0)),
          formatToCurrency(items.reduce((p, c) => p + ((c.lineTotalWithVAT || 0) - (c.lineTotal || 0)), 0)),
          '',
          ''
        ]
      : null;

  return (
    <Box>
      <Filters
        queryValue={filters.q.value}
        filters={addFilters(filters, setFilters, navigate, setPage)}
        appliedFilters={applyFilters(filters, setFilters, navigate, setPage)}
        loading={filterLoading}
        onQueryChange={(e) => handleFilterChange(e, filters, setFilters, 'q', navigate, setPage)}
        onQueryClear={() => removeFilter('q', filters, setFilters, navigate, setPage)}
        autoComplete="off"
        queryPlaceholder="Filter invoice lines on description, article code, supplier, and values"
        onClearAll={() => handleFiltersClearAll(filters, setFilters, navigate, setPage)}
      />
      <DataTable
        verticalAlign="middle"
        stickyHeader
        increasedTableDensity
        columnContentTypes={['text', 'text', 'text', 'text', 'text', 'text', 'numeric', 'numeric', 'numeric', 'numeric', 'numeric', 'text', 'text']}
        totals={totals}
        showTotalsInFooter
        headings={[
          <b>Invoice #</b>,
          <b>PDF</b>,
          <b>Supplier</b>,
          <b>Date</b>,
          <b>Description</b>,
          <b>Article Code</b>,
          <b>Unit Price</b>,
          <b>Quantity</b>,
          <b>Line Total (excl. VAT)</b>,
          <b>Line Total (incl. VAT)</b>,
          <b>VAT Amount</b>,
          <b>VAT Rate</b>,
          <b>Currency</b>
        ]}
        rows={rows}
        footerContent={getTableFooter(rows, page, setPage, 'invoice lines')}
      />
    </Box>
  );
}
